import styles from './BundleSummaryFeatures.scss';

import React from 'react';

import { useTranslation } from 'react-i18next';
import { BundleSummaryFeatureValue } from 'src/api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { componentKeyV2 } from 'src/utils/ComponentKeyV2';
import { BundleSummaryFeature } from './BundleSummaryFeature';

interface BundleSummaryFeaturesProps {
  bundleSummaryFeatureValues?: Array<FlatEntry<BundleSummaryFeatureValue>>;
  hasHybridFeaturesLayout?: boolean;
  title?: string;
}

export const BundleSummaryFeatures: React.FC<BundleSummaryFeaturesProps> = ({
  bundleSummaryFeatureValues = [],
  hasHybridFeaturesLayout = false,
  title,
}) => {
  const { t } = useTranslation();
  let horizontalFeatures: Array<FlatEntry<BundleSummaryFeatureValue>> = [];
  let verticalFeatures: Array<FlatEntry<BundleSummaryFeatureValue>> = [];

  if (hasHybridFeaturesLayout) {
    horizontalFeatures = bundleSummaryFeatureValues.slice(0, 3);
    verticalFeatures = bundleSummaryFeatureValues.slice(3, 6);
  } else {
    verticalFeatures = bundleSummaryFeatureValues;
  }

  return (
    <div className={styles.bundleSummaryFeatures} role="list" aria-label={t('bundle-summary-card.bundle-features', { title })}>
      {horizontalFeatures.length > 0 && (
        <div className={styles.horizontalFeatures}>
          {horizontalFeatures.map((item, index) => (
            <BundleSummaryFeature key={componentKeyV2(item, index)} feature={item} />
          ))}
        </div>
      )}
      {verticalFeatures.length > 0 && (
        <div className={styles.verticalFeatures}>
          {verticalFeatures.map((item, index) => (
            <BundleSummaryFeature key={componentKeyV2(item, index)} feature={item} />
          ))}
        </div>
      )}
    </div>
  );
};

BundleSummaryFeatures.displayName = 'BundleSummaryFeatures';
